import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentCreatePage } from "@/pages/Admin/legal/LegalDocumentCreatePage";

export const Route = createFileRoute("/app/admin/legal/new")({
  component: LegalDocumentCreatePage,
});
